module.exports = __webpack_public_path__ + "media/05 splendid.ad6cdc71.mp3";